

export class InspectionOrderNotFound extends Error {
    constructor(message: string = 'No existen inspecciones pendientes') { 
        super(message);
        this.name = 'InspectionOrderNotFound';
    }
}

/**
 * Rechazo de negocio de un archivo: el usuario recibe una alerta, no se reporta como excepción y
 * la cola de reintentos lo trata como PERMANENTE. Reintentar no puede cambiar el resultado — un
 * archivo de 0 bytes, uno ilegible o una foto negra siguen siéndolo en el siguiente intento.
 */
export class PhotoRejectedError extends Error {
    constructor(message: string, name: string) {
        super(message);
        this.name = name;
    }
}

export class FileSizeLimitError extends PhotoRejectedError {
    constructor(message: string) {
        super(message, 'FileSizeLimitError');
    }
}

export class EmptyFileError extends PhotoRejectedError {
    constructor(message: string) {
        super(message, 'EmptyFileError');
    }
}

export class UndecodableFileError extends PhotoRejectedError {
    constructor(message: string) {
        super(message, 'UndecodableFileError');
    }
}

/**
 * S3 rechazó la subida por la policy de la URL prefirmada: tamaño fuera del rango firmado o
 * content-type distinto del que se firmó.
 *
 * Es rechazo del ARCHIVO y no fallo de red, aunque ocurra durante la subida: reintentarlo produce
 * exactamente el mismo rechazo, porque la condición está en la firma. Por eso hereda de
 * `PhotoRejectedError` — para que la cola no lo reencole y el usuario vea el motivo en vez de un
 * «revisá tu conexión».
 */
export class UploadPolicyRejectedError extends PhotoRejectedError {
    constructor(message: string) {
        super(message, 'UploadPolicyRejectedError');
    }
}

export class BlackImageError extends PhotoRejectedError {
    constructor(message: string) {
        super(message, 'BlackImageError');
    }
}
